import React from 'react';

import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function Header() {
  const history = useHistory();
  return (
    <div className="d-flex align-items-center m-1">
      <div className="col-md-8 col-lg-9 col-sm-5 col-5">
        <h1 className="title gray-800 mb-0 fs-3 fs-md-1">Automation</h1>
      </div>
      <div className="col-md-4 col-lg-3 col-sm-7 col-7 d-flex justify-content-end">
        <Button className="p-button p-button-primary" onClick={() => history.push('/workflow-automation/add')}>
          <i className="icon-add F-size14 me-1 white-icon"></i>Add Automation Rule
        </Button>
      </div>
    </div>
  );
}
